import {select, take, put} from 'redux-saga/effects';

import {storeModalInUrl, removeModalFromUrl} from 'utils/modals';

import {
  OPEN_MODAL,
  CLOSE_MODAL,
  CLOSE_ALL_MODALS,
  removeModalDataFromStore
} from './';
import {selectModalData, selectAllOpenModals} from './selectors';

function* modalsSaga() {
  while (true) {
    const action = yield take([OPEN_MODAL, CLOSE_MODAL, CLOSE_ALL_MODALS]);

    if (action.type === OPEN_MODAL) {
      if (action.payload.url) {
        storeModalInUrl({
          name: action.payload.modalName,
          ...action.payload.data
        });
      }
    }

    if (action.type === CLOSE_MODAL) {
      const modalData = yield select(selectModalData(action.payload.modalName));

      removeModalFromUrl({...modalData, name: action.payload.modalName});

      yield put(removeModalDataFromStore(action.payload.modalName));
    }

    if (action.type === CLOSE_ALL_MODALS) {
      const openedModals = yield select(selectAllOpenModals());

      Object.entries(openedModals).map(([modalName, {data}]: any) =>
        removeModalFromUrl({...data, name: modalName})
      );

      yield* Object.keys(openedModals).map(modalName =>
        put(removeModalDataFromStore(modalName))
      );
    }
  }
}

export default modalsSaga;
